import React, {Component} from "react";
import axios from "axios";
import {Input, Modal, Select, message} from "antd";

const Option = Select.Option;

class SaveModal extends Component {

  state = {
    name: "",
    categories: [],
    selectedCategory: "",
    dataTypes: [],
    selectedDataType: "",
    description: "",
    fileName: ""
  };

  constructor() {
    super();
    this.fetchCategories = this.fetchCategories.bind(this);
    this.fetchDataTypes = this.fetchDataTypes.bind(this);
    this.onCategorySelectChange = this.onCategorySelectChange.bind(this);
    this.onTypeSelectChange = this.onTypeSelectChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onOk = this.onOk.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.clearState = this.clearState.bind(this);
  }

  componentDidMount() {
    this.fetchCategories();
    this.fetchDataTypes();
  }

  render() {
    if (this.props.visible) {
      const type = this.isModel(this.props.item.type) ? "模型" : "数据集";
      return (
        <Modal
          title={`保存${type}`}
          visible={this.props.visible}
          maskClosable
          onOk={this.onOk}
          onCancel={this.onCancel}
        >
          <div style={{marginBottom: 8}}>
            <label>类别</label>
            <Select style={{width: "100%"}} onChange={this.onCategorySelectChange}>
              {
                this.state.categories.map(category => (
                  <Option key={category.code} value={category.code}>{category.name}</Option>
                ))
              }
            </Select>
          </div>
          {
            !this.isModel(this.props.item.type)
            &&
            <div style={{marginBottom: 8}}>
              <label>格式</label>
              <Select style={{width: "100%"}} onChange={this.onTypeSelectChange}>
                {
                  this.state.dataTypes.map(dataType => (
                    <Option key={dataType.code} value={dataType.code}>{dataType.name}</Option>
                  ))
                }
              </Select>
            </div>
          }
          <div style={{marginBottom: 8}}>
            <label>名称</label>
            <Input name="name" placeholder={`${type}名字`} value={this.state.name} onChange={this.onChange}/>
          </div>
          <div>
            <label>描述</label>
            <Input name="description" placeholder={`${type}描述`} value={this.state.description} onChange={this.onChange}/>
          </div>
        </Modal>
      );
    } else {
      return null;
    }
  }

  fetchCategories() {
    axios({
      url: `/api-bigdata/categories`,
      method: "GET"
    }).then(
      response => {
        this.setState({
          categories: response.data
        })
      }
    ).catch(
      ex => {
        console.error("SaveModal fetchCategories exception:", ex);
      }
    )
  }

  fetchDataTypes() {
    axios({
      url: `/api-bigdata/dataTypes`,
      method: "GET"
    }).then(
      response => {
        this.setState({
          dataTypes: response.data
        })
      }
    ).catch(
      ex => {
        console.error("SaveModal fetchDataTypes exception:", ex);
      }
    )
  }

  onCategorySelectChange(value) {
    console.log("SaveModal onCategorySelectChange:", value);
    this.setState({
      selectedCategory: value
    })
  }

  onTypeSelectChange(value) {
    console.log("SaveModal onTypeSelectChange:", value);
    this.setState({
      selectedDataType: value
    })
  }

  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  onOk() {
    console.group("SaveModal onOk");
    console.log("name:", this.state.name);
    console.log("description:", this.state.description);
    console.log("path:", this.props.item);
    console.log("projectId:", this.props.projectId);
    console.groupEnd();

    const type = this.isModel(this.props.item.type) ? "model" : "dataset";

    const loading = message.loading("保存中，请稍候...", 0);

    if (type === "dataset") {
      const data = {
        categoryCode: this.state.selectedCategory,
        dataTypeCode: this.state.selectedDataType,
        name: this.state.name,
        description: this.state.description,
        srcPath: this.props.item.value,//`dataset${this.props.item.value.slice(this.props.item.value.indexOf("/"))}`
        projectId: this.props.projectId,
        projectName: this.props.projectName,
        userId: this.props.userId,
        tenant: this.props.enterpriseId,
        system: false,
      };
      axios({
        url: `/api-bigdata/datasets`,
        method: "POST",
        data: data
      }).then(
        response => {
          console.log("SaveModal save dataset:", response.data);
          message.destroy();
          message.success("数据集保存成功");

        }
      ).catch(
        ex => {
          console.error("SaveModal save dataset exception:", ex);
          message.destroy();
          message.error("数据集保存失败");
        }
      );
    } else if (type === "model") {
      const data = {
        name: this.state.name,
        description: this.state.description,
        path: this.props.item.value,//`model${this.props.item.value.slice(this.props.item.value.indexOf("/"))}`
        enterpriseId: this.props.enterpriseId,
        userId: this.props.userId,
        projectId: this.props.projectId,
        projectName: this.props.projectName,
        categoryCode: this.state.selectedCategory
      };
      axios({
        url: `/api-bigdata/models`,
        method: "POST",
        data: data
      }).then(
        response => {
          console.log("SaveModal save model:", response.data);
          message.destroy();
          message.success("模型保存成功");
        }
      ).catch(
        ex => {
          console.error("SaveModal save model exception:", ex);
          message.destroy();
          message.error("模型保存失败");
        }
      );
    }
    this.props.clear();
    this.clearState();
  }

  onCancel() {
    console.log("SaveModal onCancel");
    this.props.clear();
  }

  isModel(str) {
    let type = str.split("_")[0].toLowerCase();
    console.log("SaveModal isModel:", type);
    return type === "model";
  }

  clearState() {
    this.setState({
      name: "",
      description: ""
    })
  }
}

export default SaveModal;
